"use client";
import { WhyChooseUsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const WhyChooseUs: FC<WhyChooseUsSectionProps> = () => {
  return (
    <h3
      style={{
        backgroundColor: "black",
        color: "white",
        textAlign: "center",
        padding: 50,
      }}
    >
      WhyChooseUs
    </h3>
  );
};

export default WhyChooseUs;
